// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Preference_checkbox__37i4d"};